<template>
  <div class="users">

    <div id="user-count-stats" class="d-flex mt-4">
      <small class="text-muted text-center mr-3 mt-1" style="font-size: 1rem;">{{  users && users.length > 0 ? 'RESULTS' : 'NO RESULTS' }}</small>

      <b-badge v-if="countLabel" class="mr-3 mt-1" style="opacity: 80%; font-size: 0.9rem;" variant="dark">
        <Icon2 v-if="countLabel.icon" v-b-tooltip.hover :title="$helpers.prettify(countLabel.type)" :icon="countLabel.icon"/>
        <span class="mx-1">{{countLabel.text}}</span>
      </b-badge>

      <b-form inline>
        <label class="text-muted mr-sm-2 ml-2 text-center" for="stats-select-from">FROM</label>
        <Datepicker id="stats-select-from" class="mb-2 mr-sm-2 mb-sm-0" input-class="form-control" :value="fromDate" @input="updateFrom($event)" name="from-date" monday-first></datepicker>
        <label class="text-muted mr-sm-2 text-center" for="stats-select-from">TO</label>
        <Datepicker id="stats-select-to" class="mb-2 mr-sm-2 mb-sm-0" input-class="form-control" :value="toDate" @input="updateTo($event)" :disabled-dates="disabledToDates" name="to-date" monday-first></datepicker>

        <b-form-select id="users-select-type" v-model="selectedRangeType" class="mr-2" :options="rangeTypeOptions"></b-form-select>
      </b-form>

      <div  class="flex-grow-1">
        <b-button-group>
          <b-input-group>
            <b-form-input ref="search" autocomplete="false" v-model="nameFilter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-button variant="btn-outline-light" :disabled="!nameFilter" @click="nameFilter = ''"><Icon2 icon="Search_backspace"/></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-button-group>
      </div>
    </div>

    <div class="d-flex">
      <b-badge class="mr-2 mt-3" style="opacity: 80%; font-size: 0.9rem;" v-for="label in filterLabels" :key="label.text" variant="dark">
        <Icon2 v-if="label.icon" v-b-tooltip.hover :title="$helpers.prettify(label.type)" :icon="label.icon"/>
        <span class="mx-1">{{label.text}}</span>
        <b-badge v-if="label.type != 'stats'" href="#" @click.stop="removeFilterLabel(label)">&#x2716;</b-badge>
      </b-badge>
    </div>

    <div class="mt-3">
      <b-table hover striped :items="users" :fields="fields" :per-page="perPage" :current-page="currentPage">

        <template v-slot:cell(edit_user)="row">
          <div class="d-flex justify-content-center">
            <b-button size="sm" variant="primary" @click="setupEditor(row)" class="mr-2">
              <Icon2 icon="edit"/>
            </b-button>
          </div>
        </template>

        <template v-slot:row-details="row">
          <b-container>
            <form autocomplete="off">
              <input autocomplete="false" name="hidden" type="text" style="display:none;">
              <b-form-group label="ID" label-for="id-input" horizontal :label-cols="2">
                <id-input id="id-input" :value="row.item.id"/>
              </b-form-group>
              <b-form-group label="Username" label-for="username-input" horizontal :label-cols="2">
                <b-form-input id="username-input" :value="row.item.username" @input="checkUsername($event, row.item)" :state="usernameState" role="presentation" autocomplete="off"></b-form-input>
              </b-form-group>
              <b-form-group label="Country" label-for="users-select-geo" horizontal :label-cols="2">
                <b-form-select id="users-select-geo" v-model="row.item.country" :options="geoOptions"></b-form-select>
              </b-form-group>
              <b-form-group v-if="$config.hasAdultCheck" label="Is Adult" label-for="is-adult" horizontal :label-cols="2">
                <b-form-checkbox switch v-model="row.item.is_adult"></b-form-checkbox>
              </b-form-group>
              <b-form-group v-if="row.item.type == 'partner'" label="Partner" label-for="users-select-partner" horizontal :label-cols="2">
                <b-form-select id="users-select-partner" v-model="row.item.partner_id" :options="partnerOptions"></b-form-select>
              </b-form-group>
              <b-form-group v-if="row.item.type == 'partner'" label="Allow Dashboard login" label-for="users-allow-dashboard" horizontal :label-cols="2">
                <b-form-checkbox id="users-allow-dashboard" v-model="allowPartnerDashboard"></b-form-checkbox>
              </b-form-group>
<!--
              <b-form-group label="Set New Password" label-for="password-input" horizontal :label-cols="2">
                <b-input-group>
                  <b-form-input id="password-input" autocomplete="new-password" data-lpignore="true" :type="showPassword ? 'text' : 'password'" v-model="row.item.password" ></b-form-input>
                  <b-input-group-append>
                    <b-button :pressed.sync="showPassword">
                      <font-awesome-icon :icon="showPassword ? 'eye-slash' : 'eye'"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
-->
              <b-form-group v-if="Object.keys(row.item.thirdparty_consent).length > 0" label="Third Party Consent" label-for="users-thirdparty-consent" horizontal :label-cols="2">
                <UserThirdPartyConsent id="users-thirdparty-consent" v-model="row.item.thirdparty_consent" :user="row.item"></UserThirdPartyConsent>
              </b-form-group>
              <b-form-group label="Mailing List Subscriptions" label-for="users-list-subscriptions" horizontal :label-cols="2">
                <UserListSubscriptions id="users-list-subscriptions" v-model="row.item.list_subscriptions" :user="row.item"></UserListSubscriptions>
              </b-form-group>
              <b-form-group label="Actions" label-for="actions-bar" horizontal :label-cols="2">
                <b-button-group id="actions-bar">
                  <b-button @click="saveModifications(row.item)" variant="primary">
                    <Icon2 icon="Save"/>
                    <span class="ml-2">Save Modifications</span>
                  </b-button>
                  <b-button @click="sendPasswordResetMail(row.item.id)" variant="primary">
                    <font-awesome-icon icon="at"/>
                    <span> Send Password reset mail</span>
                  </b-button>
                  <b-button v-if="row.item.type != 'customer' && $config.use2FA" id="2fa-info-button" @click="send2FAInfo(row.item.username)" variant="primary">
                    <font-awesome-icon icon="at"/>
                    Send 2FA info mail
                  </b-button>
                  <b-button v-if="row.item.status != 'locked'" @click="lockUser(row.item.id)" variant="danger">
                    <font-awesome-icon icon="ban"/>
                    <span> Lock Account</span>
                  </b-button>
                  <b-button v-if="row.item.status != 'subscribed' && row.item.subscription_offer != null" @click="reactivateUser(row.item.id)" variant="primary">
                    <font-awesome-icon icon="door-open"/>
                    <span> Reactivate</span>
                  </b-button>
                  <b-button @click="showWatchedItems(row.item.id)" variant="primary">
                    <font-awesome-icon icon="search"/>
                    <span> Show Watched Items</span>
                  </b-button>
                  <b-button @click="showOrders(row.item.id)" variant="primary">
                    <font-awesome-icon icon="search"/>
                    <span> Show Order Overview</span>
                  </b-button>
                </b-button-group>
              </b-form-group>
            </form>
          </b-container>

        </template>

      </b-table>
    </div>

    <div v-if="perPage" class="d-flex justify-content-center">
      <b-pagination :total-rows="users.length" :per-page="perPage" v-model="currentPage"/>
    </div>

    <AddUser ref="addUser"/>

    <CustomerOrders ref="customerOrders"/>

    <b-modal hide-footer size="lg" v-model="showContentModal">
      <WatchedItemsTable :url="watchedItemsUrl"/>
    </b-modal>

    <iframe id="export-users-frame" style="display:none;"></iframe>

  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker"
import IdInput from '../components/IdInput.vue'
import AddUser from '../components/AddUser.vue'
import WatchedItemsTable from '../components/WatchedItemsTable.vue'
import CustomerOrders from '../components/CustomerOrders.vue'
import UserListSubscriptions from '../components/UserListSubscriptions.vue'
import UserThirdPartyConsent from '../components/UserThirdPartyConsent.vue'

export default {
  name: 'Users',

  components: {
    Datepicker,
    IdInput,
    AddUser,
    WatchedItemsTable,
    CustomerOrders,
    UserListSubscriptions,
    UserThirdPartyConsent
  },

  data() {
    return {
      currentPage: 1,
      perPage: 20,
      nameFilter: '',
      typeFilter: 'customer',
      statusFilter: 'subscribed',
      countryFilter: '*',
      showPassword: false,
      geoOptions: [],
      partnerOptions: [],
      allowPartnerDashboard: false,

      showContentModal: false,
      watchedItemsUrl: null,
      usernameState: null,
      fromDate: null,
      toDate: null,
      disabledToDates: {to: null},
      selectedRangeType: 'created-desc',
      rangeTypeOptions: [
        {value: "created-asc", text: "Created Date ascending"},
        {value: "created-desc", text: "Created Date descending"},
        {value: "updated-asc", text: "Update Date ascending"},
        {value: "updated-desc", text: "Update Date descending"},
        {value: "start-asc", text: "Subscription Start Date ascending"},
        {value: "start-desc", text: "Subscription Start Date descending"}
      ],


      users: [],

      fields: [
        {key: 'username', label: 'Email', sortable: true},
        {key: 'type', sortable: true},
        {key: 'org', sortable: true},
        {key: 'inserted_at', label: 'Created', sortable: true, formatter: this.$helpers.dtFormatter},
        {key: 'status', sortable: true},
        {key: 'subscription_offer', label: 'Offer', sortable: true},
        {key: 'subscription_start', label: 'Start', sortable: true, formatter: this.$helpers.dtFormatter},
        {key: 'subscription_end', label: 'End', sortable: true, formatter: this.$helpers.dtFormatter},
        {key: 'country', sortable: true, formatter: this.$store.getters.countryFormatter},
        {key: 'is_paying_customer', label: 'Paying?', sortable: true, formatter: this.$helpers.booleanFormatter},
        {key: 'email_subscription', label: "Newsletter?", sortable: true, formatter: this.$helpers.booleanFormatter},
        {key: 'edit_user', label: 'Edit'}
      ],


    };
  },

  watch: {
    typeFilter() { this.loadUsers() },
    statusFilter() { this.loadUsers() },
    countryFilter() { this.loadUsers() },
    nameFilter() { this.loadUsers() },
    selectedRangeType() { this.loadUsers() }
  },

  computed: {
    countLabel() {
      if(this.users && this.users.length > 0) {
        const count = this.users.length
        const quantifier = count == 1 ? 'user' : 'users'
        return {text: `${count} ${quantifier}`, icon: "Menu_Stats", value: count, type: "stats"}
      }
      return null
    },

    filterLabels() {
      let labels = []

      if(this.typeFilter != '*') {
        labels.push({text: this.$helpers.prettify(this.typeFilter), icon: "Menu_Users", value: this.typeFilter, type: "user_type"});
      }

      if(this.statusFilter != '*') {
        labels.push({text: this.$helpers.prettify(this.statusFilter), icon: "labels", value: this.statusFilter, type: "user_status"});
      }

      if(this.countryFilter != '*') {
        labels.push({text: this.$store.getters['app/countryFormatter'](this.countryFilter), icon: "globe", value: this.countryFilter, type: "user_country"});
      }

      if(this.nameFilter) labels.push({text: `"${this.nameFilter}"`, icon: "search", type: "search"})

      return labels
    }
  },
  
  methods: {
    load() {
      fetch('/admin/api/v2/users/geo-options')
      .then(function(resp) {
        return resp.json();
      })
      .then(resp => {
        this.geoOptions = resp.data
        fetch('/admin/api/v2/partners/select-options')
        .then(function(resp) {
          return resp.json();
        })
        .then(resp => {
          this.partnerOptions = resp.data
          this.loadUsers()
        })
      })
    },

    loadUsers() {
      fetch(`/admin/api/v2/users?type=${this.typeFilter}&status=${this.statusFilter}&country=${this.countryFilter}&match=${this.nameFilter || '*'}&order_by=${this.selectedRangeType}&from=${this.$helpers.dateFormatter(this.fromDate)}&to=${this.$helpers.dateFormatter(this.toDate)}`)
      .then(resp => {
        if(resp.status == 200) return resp.json()
        else throw Error(resp.statusText)
      })
      .then(resp => {
        this.users = resp.data
      })
      .catch(() => {
        this.$root.app.showAlert('Error loading users', 'danger')
      })
    },

    removeFilterLabel(label) {
      if(label.type == "user_type") {
        this.typeFilter = '*'
        this.$root.$emit('user-type-reset');
      }
      else if(label.type == "user_status") {
        this.statusFilter = '*'
        this.$root.$emit('user-status-reset');
      }
      else if(label.type == "user_country") {
        this.countryFilter = '*'
        this.$root.$emit('user-geo-reset');
      }
      else if(label.type == "search") {
        this.nameFilter = ''
      }
    },

    checkUsername(username, item) {
      username = username || ""
      username = username.trim()
      if(username == "") {
        this.usernameState = null
      }
      else {
        fetch(`/admin/api/v2/users/is-user/${username}`)
        .then(resp => {
          if(resp.status == 200) this.usernameState = (username == item.username)
          else {
            this.usernameState = this.$helpers.isValidEmail(username)
          }
        })
      }

      item.username = username
    },

    setupEditor(row) {
      this.allowPartnerDashboard = (row.item.partner_type == 'admin')
      row.toggleDetails()
    },

    saveModifications(item) {
      item.partner_type = (item.type == 'partner' ? (this.allowPartnerDashboard ? 'admin' : 'user') : null)

      fetch(`/admin/api/v2/users/${item.id}`, {method: 'PUT', body: JSON.stringify({data: item})})
      .then(resp => {
        if(resp.status == 200) {
          this.load()
          return resp.json()
        }
        else if(resp.status == 400) {
          return resp.json()
        }
        else throw Error(resp.statusText)
      })
      .then((json) => {
        if(json.status == "ok") {
          this.$root.app.showAlert('User successfully updated', 'success')
        }
        else if(json.status == "error") {

          switch(json.type) {
            case "username_already_exists":
              this.$root.app.showErrorDialog("Username already exists. Please pick a unique username.", "Error")
              break;

            case "invalid_password":
              this.$root.app.showErrorDialog("Invalid password. Please pick a password of at least 8 characters that contains no whitespace.", "Error")
              break;
          }
        }
        else throw Error()
      })
      .catch(() => {
        this.$root.app.showAlert('Error updating user', 'danger')
      })
    },

    sendPasswordResetMail(id) {
      fetch(`/admin/api/v2/users/${id}/password-reset`, {method: 'POST'})
      .then(resp => {
        if(resp.status == 200) {
          this.$root.app.showAlert('Password reset mail has been send', 'success')
        }
        else throw Error(resp.statusText)
      })
      .catch(() => {
        this.$root.app.showAlert('Error sending password reset mail', 'danger')
      })
    },

    lockUser(id) {
      fetch(`/admin/api/v2/users/${id}/lock`, {method: 'POST'})
      .then(resp => {
        if(resp.status == 200) {
          this.$root.app.showAlert('User is locked', 'success')
          this.load()
        }
        else throw Error(resp.statusText)
      })
      .catch(() => {
        this.$root.app.showAlert('Error locking user', 'danger')
      })
    },

    reactivateUser(id) {
      fetch(`/admin/api/v2/users/${id}/reactivate`, {method: 'POST'})
      .then(resp => {
        if(resp.status == 200) {
          this.$root.app.showAlert('User is reactivated', 'success')
          this.load()
        }
        else throw Error(resp.statusText)
      })
      .catch(() => {
        this.$root.app.showAlert('Error reactivating user', 'danger')
      })
    },

    showWatchedItems(id) {
      this.watchedItemsUrl = `/admin/api/v2/users/${id}/watched-items`
      this.showContentModal = true
    },

    showOrders(id) {
      this.$refs.customerOrders.show(id)
    },

    setTypeFilter(type) {
      this.typeFilter = type
    },

    setStatusFilter(status) {
      this.statusFilter = status
    },

    setCountryFilter(country) {
      this.countryFilter = country
    },

    addUser() {
      this.$refs.addUser.show()
    },

    handleFiltered(items) {
      this.currentPage = 1
      this.totalRows = items.length
    },

    setDisabledToDates(date) {
      if(date) {
        this.disabledToDates.to = new Date(date)
      } else {
        this.disabledToDates = {to: null}
      }
    },

    setDefaultDateRange() {
      let from = new Date()
      let to = new Date()

      from.setDate(from.getDate() - 7)
      to.setDate(to.getDate())

      this.fromDate = from
      this.toDate = to
    },

    updateFrom(date) {
      this.fromDate = date
      this.setDisabledToDates(date)
      this.loadUsers();
    },

    updateTo(date) {
      this.toDate = date
      this.loadUsers();
    },

    exportUsers() {
      this.$http.postJSON(
        "/admin/api/v2/users/build-export",
        {},
        (resp) => {
          let file_name = "/admin/api/v2/users/download-export/" + resp.data;
          document.getElementById('export-users-frame').src = file_name;
        },
        (status, html) => {
          this.clear()
          this.$root.app.showErrorDialog(html, status.toString())
        }
      )
    },

    send2FAInfo(email) {
      let payload = JSON.stringify({
        email: email
      })

      fetch('/admin/api/v2/admin/2fa-request', {method: 'POST', body: payload})
      .then(resp => {
        if(resp.status != 200) {
         this.$root.app.showAlert("User not found", "danger")
        }
        else {
          this.$root.app.showAlert("2-step verification instructions sent by email", "success")
        }
      })

    }

  },

  mounted() {
    this.$root.app.setActivePageTitle("Users", false)
    this.$root.$emit('set-toolbar', 'user-toolbar', 'user')

    this.load()
  },

  created() {
    this.$root.$on('user-export', this.exportUsers)
    this.$root.$on('user-type-filter', this.setTypeFilter)
    this.$root.$on('user-status-filter', this.setStatusFilter)
    this.$root.$on('user-geo-filter', this.setCountryFilter)
    this.$root.$on('user-add', this.addUser)
    this.$root.$on('user-refresh', this.load)

    this.setDefaultDateRange()
  },

  beforeDestroy() {
    this.$root.$off('user-export', this.exportUsers)
    this.$root.$off('user-type-filter', this.setTypeFilter)
    this.$root.$off('user-status-filter', this.setStatusFilter)
    this.$root.$off('user-geo-filter', this.setCountryFilter)
    this.$root.$off('user-add', this.addUser)
    this.$root.$off('user-refresh', this.load)
  }
}
</script>

<style>
.no-head {
  display: none;
}



</style>
